<template>
	<div class="comp">
		<el-dialog :custom-class="'customClass'" :visible.sync="dialogState" :close-on-click-modal="false" width="400px" :show-close="state!==2" >
			<div class="dialog">
				<div class="scanBox" v-if="state===1">
					<img class="scanImg" src="../assets/img/scan1.png"/>
					<div class="scanText">请扫顾客二维码</div>
					<div class="scanA"></div>
				</div>
				<div class="scanBox" v-if="state===2" >
					<img class="scanImg" src="../assets/img/scan2.png"/>
					<div class="scanText">订单支付中…</div>
					<div class="scanA">剩余支付时间 {{daojishi}} 秒</div>
				</div>
				<div class="scanBox" v-if="state===3" >
					<img class="scanImg" src="../assets/img/scan4.png"/>
					<div class="scanText" style="color:red;">扫码失败,请重新扫码</div>
					<div class="scanA" style="color:#797979;text-decoration: underline;">
						<div @click="reScan">重新扫码</div>
					</div>
					<div>{{res_scan.info}}</div>
				</div>
				<div class="scanBox" v-if="state===4" >
					<img class="scanImg" src="../assets/img/scan3.png"/>
					<div class="scanText" style="color:#009B5D">支付成功</div>
					<div class="scanA" ></div>
				</div>
				<div class="scanBox" v-if="state===5" >
					<img class="scanImg" src="../assets/img/scan4.png"/>
					<div class="scanText" style="color:red;">支付失败</div>
					<div class="scanA" style="color:#797979;text-decoration: underline;">支付超时</div>
				</div>
			</div>
			<!-- <input style="width:0px;height: 0px;border:0;" v-model="authCode" @change="changeInput" ref="input"/> -->
		</el-dialog>
		<audio src="../assets/audio/paySuccess.mp3" controls="controls" muted ref="paySuccess" hidden></audio>
		<audio src="../assets/audio/pleaseShowScan.mp3" controls="controls" muted ref="pleaseShowScan" hidden></audio>
	</div>
</template>
<script>
	export default {
		data() {
			return {
				dialogState:true,
				state:1,      // 
				authCode:'',
				
				interval:null,
				interval1:null,
				daojishi:60,
				
				res_scan:{}
			}
		},
		computed:{
			curShopId(){
				return this.$store.state.shopId;
			},
		},
		props: {
			orderType:{
				type:String,
				default:''
			},
			orderNum:{
				type:String,
				default:''
			}
		},
		watch:{
			dialogState(n){
				if(n===false){
					if(this.state===1){
						this.$emit('submit','cancel')
					}else if(this.state===3){
						this.$emit('submit','cancel')
					}else if(this.state===4){
						this.$emit('submit','success')
					}else if(this.state===5){
						this.$emit('submit','cancel')
					}
				}
			}
		},
		mounted() {
			document.onkeypress = (e) => {
				console.log(e)
				if(this.authCode.length<=18){
					console.log(this.authCode)
					if(this.state===1){
						if (e.which == 13) {
							this.pay();
							// this.authCode = '';
						}else{
							this.authCode += String.fromCharCode(e.which);
						}
					}
				}
			}
			this.$nextTick(()=>{
				this.$refs.pleaseShowScan.play()
			})
		},
		methods: {
			reScan(){
				this.state=1;
				this.authCode='';
			},
			pay(){
				let orderType = 1;
				if(this.orderType==="order"){
					orderType = 1;
				}else if(this.orderType==="recharge"){
					orderType = 2;
				}else if(this.orderType==="exchangeGoods"){
					orderType = 3;
				}
				console.log({
					orderType:orderType,   // 1消费订单;2充值订单;3换货订单
					authCode:this.authCode,
					orderNum:this.orderNum,
				})
				this.$http.get('/api/Pay/JL/MainScanPay', {
					orderType:orderType,   // 1消费订单;2充值订单;3换货订单
					authCode:this.authCode,
					orderNum:this.orderNum,
				}).then(res => {
					if (res.code == 0) {
						if(res.data==='true'){
							this.state=2; // 扫码成功
							this.interval = setInterval(()=>{
								this.getPayResult();
							},5000)
							this.interval1 = setInterval(()=>{
								this.daojishi--;
								if(this.daojishi===-1){
									this.daojishi=60;
									this.state=5; // 支付失败
									clearInterval(this.interval)
									clearInterval(this.interval1)
								}
							},1000)
						}else{
							this.state=3;  // 扫码失败
							this.res_scan = res;
						}
					}
				})
			},
			getPayResult(){
				this.$http.get('/api/pay/jl/payState', {shopId:this.curShopId,orderNum:this.orderNum}).then(res => {
					if (res.code == 0) {
						if(res.data=='success'){
							this.state=4;  // 支付成功
							if(this.interval){
								clearInterval(this.interval1)
								clearInterval(this.interval)
							}
							this.$refs.paySuccess.play()
						}
					}
				})
			},
		},
		beforeDestroy(){
			document.onkeypress=()=>{};
		}
	}
</script>
<style scoped lang="scss">
	.comp{
		::v-deep .customClass{
			border-radius: 10px;
		}
		.dialog{
			.scanBox{
				text-align: center;
				padding-top:30px;
				.scanImg{
					width:90px;
				}
				.scanText{
					font-size: 24px;
					padding:30px 0 10px;
				}
				.scanA{
					font-size: 16px;
					padding:10px 0 10px;
					color:#797979;
					cursor: pointer;
				}
			}
		}
	}
</style>
